import React from "react";
import {
  EMAIL_PREFERENCES,
  PROJECTS,
  MY_ASSETS,
  TEAM_TEMPLATES,
  MY_COMPONENTS,
  QUICK_START,
  ROOT,
  MY_FOLDERS,
  BRANDKIT,
  MY_WORKSPACE,
  MY_APPS,
  MAGICAL,
  TEMPLATES_SCREEN,
  BILLING_AND_PAYMENT,
  BILLING_PLANS,
  MY_ACCOUNT,
  DOCUMENTS,
  FAVORITES,
  REWARDS,
  PUBLISHING,
  ANALYTICS,
} from "./routes";
import NewProject from "../_components/home/NewProject";
import TldrOrgDropdown from "../_components/common/TldrOrgDropdown";
import {
  FaBars,
  FaChartBar,
  FaCalendarAlt,
  FaClock,
  FaEgg,
  FaFolder,
  FaPalette,
  FaPallet,
  FaPuzzlePiece,
  FaRobot,
  FaFile,
  FaHeart,
  FaThLarge,
  FaDraftingCompass,
  FaCrown,
  FaFileSignature,
  FaPenAlt,
  FaCheckDouble,
  FaPencilAlt,
  FaCalendarCheck,
  FaImage,
  FaIcons,
  FaCommentDots,
  FaRocket,
  FaBullseye,
} from "react-icons/fa";
import { Box } from "@chakra-ui/react";

export const FONT_WEIGHTS = {
  100: { fontWeight: 100, label: "Thin" },
  "100italic": { fontWeight: 100, label: "Thin italic", style: "italic" },
  200: { fontWeight: 200, label: "Extra-light" },
  "200italic": {
    fontWeight: 200,
    label: "Extra-light italic",
    style: "italic",
  },
  250: { fontWeight: 250, label: "Extra-light" },
  "250italic": {
    fontWeight: 250,
    label: "Extra-light",
    style: "italic",
  },
  300: { fontWeight: 300, label: "Light" },
  350: { fontWeight: 300, label: "Light" },
  "300italic": { fontWeight: 300, label: "Light italic", style: "italic" },
  regular: { fontWeight: 400, label: "Regular" },
  italic: { fontWeight: 400, label: "Regular italic", style: "italic" },
  500: { fontWeight: 500, label: "Medium" },
  "500italic": { fontWeight: 500, label: "Medium italic", style: "italic" },
  600: { fontWeight: 600, label: "Semi-bold" },
  "600italic": { fontWeight: 600, label: "Semi-bold italic", style: "italic" },
  700: { fontWeight: 700, label: "Bold" },
  750: { fontWeight: 750, label: "Bold" },
  "700italic": { fontWeight: 700, label: "Bold italic", style: "italic" },
  800: { fontWeight: 800, label: "Extra-bold" },
  "800italic": { fontWeight: 800, label: "Extra-bold italic", style: "italic" },
  900: { fontWeight: 900, label: "Black" },
  "900italic": { fontWeight: 900, label: "Black italic", style: "italic" },
};

export const ADD_MORE_FONTS = "+ Add fonts";

export const RND_MIN_WIDTH = "50px";

export const NUMBER_OF_USERS_TO_DISPLAY = 5;

export const EXPORT_IMAGE_ERROR_PAYLOAD = {
  message: "Something went wrong. Please try again after sometimes.",
  heading: "Failed to export image",
  type: "error",
};

export const MAIN_CONTAINER_SCROLLABLE_TARGET_ID =
  "infinite-scroll-main-container";

export const AppIdType = {
  SHOPIFY_APP: "shopify_app",
  GOOGLE_SHEETS: "google_sheets",
  GOOGLE_DRIVE: "google_drive",
  INSTAGRAM: "instagram_app",
  INSTAGRAM_BUSINESS: "instagram_business_app",
  FACEBOOK_APP: "facebook_app",
  PINTEREST_APP: "pinterest_app",
  TIKTOK_APP: "tiktok_app",
  LINKEDIN_APP: "linkedin_app",
  TWITTER_APP: "twitter_app",
  GOOGLE_MY_BUSINESS: "google_mb",
  YOUTUBE_APP: "youtube_app",
};
export const API_DEBOUNCE_TIME =
  process.env.REACT_APP_API_DEBOUNCE_TIME ?? 1000; // API debounce time in ms

export const DASHBOARD_KEY = "dashboard";
export const TEMPLATES_KEY = "templates";
export const PROJECTS_KEY = "projects";
export const AI_ASSISTANT_KEY = "ai_assistant";
export const AI_KEY = "ai";
export const FOLDERS_KEY = "folders";
export const TEAM_TEMPLATES_KEY = "team_templates";
export const COMPONENTS_KEY = "components";
export const MY_ASSETS_KEY = "my_assets";
export const BRANDKIT_KEY = "brandkit";
export const ACCOUNT_KEY = "account";
export const WORKSPACE_KEY = "workspace";
export const BILLING_KEY = "billing";
export const CONNECTED_APPS_KEY = "connected_apps";
export const EMAIL_PREFERENCES_KEY = "email_preferences";
export const EARN_REWARDS_KEY = "earn_rewards";
export const ACADEMY_KEY = "academy";
export const JOIN_COMMUNITY_KEY = "join_community";
export const GET_HELP_KEY = "get_help";
export const DOCUMENTS_KEY = "Documents";
export const FAVOURITES_KEY = "Favorites";
export const PUBLISHING_KEY = "publishing";
export const PLANNER_KEY = "planner";
export const ANALYTICS_KEY = "analytics";
export const INFO_TAB = "info";

export const DASHBOARD_SIDEBAR_MENU = [
  {
    type: "template",
    template: <NewProject></NewProject>,
  },
  {
    type: "divider",
    classes: "tldr-sidebar-hl tldr-sidebar-spacing",
  },
  {
    type: "template",
    template: (
      <Box display={["block", "block", "none", "none"]}>
        <TldrOrgDropdown type="expandable"></TldrOrgDropdown>
      </Box>
    ),
  },
  {
    key: DASHBOARD_KEY,
    type: "item",
    icon: FaThLarge,
    label: "Dashboard",
    classes: `quikc-start`,
    iconClasses: "",
    extraData: {
      path: [QUICK_START, ROOT],
    },
  },
  {
    type: "subMenu",
    icon: FaDraftingCompass,
    title: "Design & Videos",
    menu: [
      {
        key: TEMPLATES_KEY,
        type: "item",
        icon: FaIcons,
        label: "Browse Templates",
        extraData: {
          path: TEMPLATES_SCREEN,
        },
      },
      {
        key: PROJECTS_KEY,
        type: "item",
        icon: FaImage,
        label: "My Projects",
        extraData: {
          path: PROJECTS,
        },
      },
    ],
  },
  {
    type: "subMenu",
    icon: FaRobot,
    title: "Content Writing",
    tooltip: "Auto generate content",
    menu: [
      {
        key: AI_ASSISTANT_KEY,
        type: "item",
        icon: FaPencilAlt,
        label: "AI Writing tools",
        extraData: {
          path: MAGICAL,
        },
      },
      {
        key: DOCUMENTS_KEY,
        type: "item",
        icon: FaFile,
        label: "Documents",
        extraData: {
          path: DOCUMENTS,
        },
      },
      {
        key: FAVOURITES_KEY,
        type: "item",
        icon: FaHeart,
        label: "Favorited Results",
        extraData: {
          path: FAVORITES,
        },
      },
    ],
  },
  {
    title: "Content Planner",
    icon: FaCalendarAlt,
    type: "subMenu",
    menu: [
      {
        key: PUBLISHING_KEY,
        type: "item",
        icon: FaCalendarAlt,
        label: "Content Calendar",
        extraData: {
          path: PUBLISHING,
        },
      },
      {
        key: PLANNER_KEY,
        type: "item",
        icon: FaCalendarCheck,
        label: "Content Planner",
        extraData: {
          path: "/planner",
        },
      },
      {
        key: ANALYTICS_KEY,
        type: "item",
        icon: FaChartBar,
        label: "Analytics (beta)",
        extraData: {
          path: ANALYTICS,
        },
      },
    ],
  },
  { type: "divider", classes: "tldr-sidebar-hl tldr-sidebar-hl-divider" },
  {
    key: BRANDKIT_KEY,
    type: "item",
    icon: FaPalette,
    label: "Brandkit",
    classes: "",
    iconClasses: "",
    extraData: {
      path: BRANDKIT,
    },
  },
  {
    title: "Library",
    icon: FaFolder,
    type: "subMenu",
    menu: [
      {
        key: FOLDERS_KEY,
        type: "item",
        icon: FaFolder,
        label: "Folders",
        classes: ``,
        iconClasses: "",
        extraData: {
          path: MY_FOLDERS,
        },
      },
      {
        key: MY_ASSETS_KEY,
        type: "item",
        icon: FaPalette,
        label: "My Assets",
        classes: ``,
        iconClasses: "",
        extraData: {
          path: MY_ASSETS,
        },
      },
      {
        key: TEAM_TEMPLATES_KEY,
        type: "item",
        icon: FaEgg,
        label: "Team Templates",
        classes: ``,
        iconClasses: "",
        extraData: {
          path: TEAM_TEMPLATES,
        },
      },
      {
        key: COMPONENTS_KEY,
        type: "item",
        icon: FaPuzzlePiece,
        label: "Components",
        tooltip: "My Components",
        classes: ``,
        iconClasses: "",
        extraData: {
          path: MY_COMPONENTS,
        },
      },
    ],
  },
];

export const TOP_BAR = [
  {
    key: "top_bar_bars",
    type: "fa",
    icon: FaBars,
    classes: `custom-tab hamburger-container`,
    iconClasses: "align-self-center hamburger",
    extraData: {
      action: "Toggle",
    },
  },
  {
    key: "top_bar_tldrdropdown",
    type: "tldrDropdown",
    classes: ``,
    iconClasses: "",
  },
];

export const BOTTOM_BAR = [
  {
    key: DASHBOARD_KEY,
    type: "fa",
    icon: FaThLarge,
    classes: `custom-tab text-capitalize`,
    iconClasses: `align-self-center`,
    label: "Dashboard",
    extraData: {
      path: [QUICK_START, ROOT],
    },
  },
  {
    key: TEMPLATES_KEY,
    type: "fa",
    icon: FaEgg,
    classes: `custom-tab text-capitalize`,
    iconClasses: `align-self-center`,
    label: "Templates",
    extraData: {
      path: TEMPLATES_SCREEN,
    },
  },
  {
    key: PROJECTS_KEY,
    type: "fa",
    icon: FaClock,
    classes: `custom-tab text-capitalize`,
    iconClasses: `align-self-center`,
    label: "Projects",
    extraData: {
      path: PROJECTS,
    },
  },
  {
    key: PUBLISHING_KEY,
    type: "fa",
    icon: FaCalendarAlt,
    classes: `custom-tab text-capitalize`,
    iconClasses: `align-self-center`,
    label: "Schedule",
    extraData: {
      path: PUBLISHING,
    },
  },
  {
    key: AI_KEY,
    type: "fa",
    icon: FaRobot,
    classes: `custom-tab text-capitalize`,
    iconClasses: `align-self-center`,
    label: "AI Writer",
    extraData: {
      path: MAGICAL,
    },
  },
];

export const AI_TABBAR = [
  { key: AI_KEY, label: "Playground", icon: FaRobot, path: MAGICAL },
  { key: DOCUMENTS_KEY, label: "Documents", icon: FaFile, path: DOCUMENTS },
  { key: FAVOURITES_KEY, label: "Favorites", icon: FaHeart, path: FAVORITES },
];

export const SETTINGS_TABBAR = [
  { key: ACCOUNT_KEY, label: "My account", path: MY_ACCOUNT },
  { key: WORKSPACE_KEY, label: "My workspace", path: MY_WORKSPACE },
  {
    key: BILLING_KEY,
    label: "Billing",
    path: BILLING_AND_PAYMENT,
    additionalPath: BILLING_PLANS,
  },
  { key: EARN_REWARDS_KEY, label: "Earn rewards($)", path: REWARDS },
  { key: BRANDKIT_KEY, label: "Brand Kit", path: BRANDKIT },
  { key: CONNECTED_APPS_KEY, label: "Connected Apps", path: MY_APPS },
  {
    key: EMAIL_PREFERENCES_KEY,
    label: "Email Preferences",
    path: EMAIL_PREFERENCES,
  },
];
export const SIMPLIFIED_PRICING_LINK = "https://simplified.co/pricing";
export const SIMPLIFIED_CHROME_PLUGIN_LINK =
  "https://chrome.google.com/webstore/detail/simplified-one-app/hibfheifkaehlpnfggmfimfbhhffcmla";

// Application static assets URLs
export const SIMPLIFIED_ASSETS_BASE_URL = "https://assets.simplified.co";
export const DASHBOARD_BANNER = `${SIMPLIFIED_ASSETS_BASE_URL}/images/dashboard-banner.png`;
export const UPGRADE_PLAN_IMAGE_LINK = `${SIMPLIFIED_ASSETS_BASE_URL}/images/upgrade-plan-modal.png`;

export const DEFAULT_ARTBOARD_DURATION = 6;
export const StoryTypes = {
  STATIC: 0,
  ANIMATED: 1,
};
export const AssetProcessingStatusTypes = {
  NOT_STARTED: 0,
  IN_PROGRESS: 1,
  PROCESSING_FAILED: 2,
  THUMBNAIL_FAILED: 3,
  DONE: 4,
};

export const DEFAULT_AUDIO_VOLUME = 0.5;
export const GLOBAL_TIMELINE_ALLOWED_DELTA = 250; // Miminum timedelta for global timeline if delta is bigger then this then timeline sync
export const TIMELINE_MINIMUM_PAGE_DURATION = 1.5; // in seconds

export const WORKAREA_LAYOUT_FIXED = "fixed";
export const WORKAREA_LAYOUT_RESPONSIVE = "responsive";
export const WORKAREA_LAYOUT_FULLSCREEN = "fullscreen";

// Bottom panel related constants
export const BottomPanelState = {
  CLOSE: "close",
  OPEN: "open",
};
export const BottomPanelViewTypes = {
  PREVIEW_ARTBOARDS: "preview_artboards",
  ARTBOARDS_GRID_VIEW: "artboards_grid_view",
  TRIM_STORY_MUSIC: "trim_story_music",
};

export const includedFeatures = [
  {
    icon: FaPallet,
    title: "Design & video editor",
    info: "Create content with one click.\nAdd your brand kit, fonts and logos for easy use",
  },
  {
    icon: FaRobot,
    title: "AI Long form Writer",
    info: "Use 40+ copywriting templates",
  },
  {
    icon: FaCalendarAlt,
    title: "Social Media Scheduler",
    info: "Schedule and publish content to all 8+ social media networks.",
  },
];

export const aiIncludedFeatures = [
  {
    icon: FaFileSignature,
    title: "Long Form Writer",
    info: "Create one-of-a-kind text for videos, ads, quotes, products, blogs, articles.",
  },
  {
    icon: FaPenAlt,
    title: "Much more Words per Month",
    info: "Write copy in seconds, get more words per month.",
  },
  {
    icon: FaCheckDouble,
    title: "Grammarly and Plagiarism Checker",
    info: "Write plagiarism-free, long-form content in 30+ languages and 10+ tones in no time!.",
  },
];

export const inviteMembersFeatures = [
  {
    icon: FaBullseye,
    title: "Assign Roles",
    info: "Designate specific roles such as admin, editor, or creator so that members know how they contribute to the project.",
  },
  {
    icon: FaCommentDots,
    title: "Real-time Communication",
    info: "Assign priorities and give feedback for fast and effective communication.",
  },
  {
    icon: FaRocket,
    title: "Share Externally or Invite Guests",
    info: "Share your projects externally with the global preview link.",
  },
];

export const AiOptions = {
  COMPLETE_COMMAND: "complete",
  REWRITE_COMMAND: "rewrite",
  EXPAND_COMMAND: "expand",
  WRITE_SECTION: "write-section",
  PLAGIARISM_CHECKER: "plagiarism",
};

export const AI_FORM_CARDS = [
  {
    id: 1,
    heading: "Premium",
    title: "AI Document Editor",
    image: "https://assets.simplified.co/images/ai1.png",
    description: "Let AI generate entire blogs, articles or essays in minutes.",
    buttonType: "hollow",
    buttonTitle: "Launch Writer",
    videoInAction: "https://www.youtube.com/embed/ShtGcsuz0PY?autoplay=1",
    icon: FaCrown,
  },
  {
    id: 2,
    heading: "50+ Templates",
    title: "Start with a template",
    image: "https://assets.simplified.co/images/ai3.png",
    description:
      "Let AI write social media captions, ads, YouTube titles, emails and more for you!",
    buttonType: "hollow",
    buttonTitle: "Explore",
    videoInAction: "https://www.youtube.com/embed/yVkEB_nVpKE?autoplay=1",
  },
  {
    id: 3,
    heading: "Design in one click",
    title: "AI Design Generater",
    image: "https://assets.simplified.co/images/ai-designer.png",
    description: "Let AI design ready-to-post graphics for your social media..",
    buttonType: "hollow",
    buttonTitle: "Design now",
    videoInAction: "https://www.youtube.com/embed/Gs9MVthtc-g?autoplay=1",
  },
];

export const AiOptionsForBubbleToolbar = [
  {
    title: "Continue",
    tooltip: "Continue your writing",
    name: AiOptions.COMPLETE_COMMAND,
    //id:"cbe89129-4520-455a-a3b5-35c521e846ef",
    id: "6c44089f-66b5-4162-8b1c-17b47a490e55",
  },
  {
    title: "Rephrase",
    tooltip: "Alternative sentence structure or wording.",
    name: AiOptions.REWRITE_COMMAND,
    id: "77441e5b-2b60-4620-9b0d-33823d5dac5b",
  },
  {
    title: "Expand",
    tooltip: "Expand a short sentence or a few words into a longer sentence.",
    name: AiOptions.EXPAND_COMMAND,
    id: "30f5d460-efce-4e89-ab68-2b2fdff011fc",
  },
  {
    title: "Write section",
    tooltip: "Expand about the topic highlighted.",
    name: AiOptions.WRITE_SECTION,
    id: "5bc5a483-cfde-4c71-8256-2b502ede1986",
  },
  {
    title: "Plagiarism check",
    icon: "",
    tooltip: "Verify the originality of content with Plagiarism checker",
    name: AiOptions.PLAGIARISM_CHECKER,
  },
];

export const AILanguages = [
  { value: "en", label: "🇺🇸  English" },
  { value: "es", label: "🇪🇸  Spanish" },
  { value: "ms", label: "🇲🇾  Malay" },
  { value: "zh-CN", label: "🇨🇳 Chinese (Simplified)" },
  { value: "pt", label: "🇵🇹  Portuguese" },
  { value: "fr", label: "🇫🇷  French" },
  { value: "swe", label: "🇸🇪 Swedish" },
  { value: "hi", label: "🇮🇳 Hindi" },
  { value: "ta", label: "🇮🇳 Tamil" },
  { value: "be", label: "🇧🇾 Belarusian" },
  { value: "bg", label: "🇧🇬 Bulgarian" },
  { value: "nl", label: "🇳🇱 Dutch" },
  { value: "de", label: "🇩🇪  German" },
  { value: "ja", label: "🇯🇵  Japanese" },
  { value: "ko", label: "🇰🇷  Korean" },
  { value: "it", label: "🇮🇹  Italian" },
  { value: "tr", label: "🇹🇷  Turkish" },
  { value: "pl", label: "🇵🇱  Polish" },
  { value: "bn", label: "🇧🇩  Bangla" },
  { value: "ru", label: "🇷🇺 Russian" },
  { value: "ar", label: "🇦🇪  Arabic" },
  { value: "id", label: "🇮🇩 Indonesian" },
];

export const AITones = [
  { value: "Formal", label: "Formal" },
  { value: "Informal", label: "Informal" },
  { value: "Optimistic", label: "Optimistic" },
  { value: "Pessimistic", label: "Pessimistic" },
  { value: "Joyful", label: "Joyful" },
  { value: "Sad", label: "Sad" },
  { value: "Sincere", label: "Sincere" },
  { value: "Hypocritical", label: "Hypocritical" },
  { value: "Fearful", label: "Fearful" },
  { value: "Hopeful", label: "Hopeful" },
  { value: "Humorous", label: "Humorous" },
  { value: "Serious", label: "Serious" },
];

export const TypeOfDesignToBePublished = {
  PROJECT: "project",
  ASSET: "asset",
};

export const EventMediaType = {
  IMAGE: "image",
  TEXT: "text",
  VIDEO: "video",
  SLIDE: "slide",
};

export const AI_MIN_LIMIT = 20;
export const AI_MAX_LIMIT = 900;

export const channelSlotDaysOptions = [
  {
    label: "Everyday",
    value: "1-7",
  },
  {
    label: "Weekdays",
    value: "1-5",
  },
  {
    label: "Weekends",
    value: "6-7",
  },
  {
    label: "Monday",
    value: "1",
  },
  {
    label: "Tuesday",
    value: "2",
  },
  {
    label: "Wednesday",
    value: "3",
  },
  {
    label: "Thursday",
    value: "4",
  },
  {
    label: "Friday",
    value: "5",
  },
  {
    label: "Saturday",
    value: "6",
  },
  {
    label: "Sunday",
    value: "7",
  },
];

export const NO_ACCESS_TO_CREATE_STORY =
  "You're currently a guest. To create design, Ask an admin to upgade you to a member.";

export const NO_ACCESS_TO_CREATE_BRANDKIT =
  "You don't have access to create brandkit. To create it, Ask an admin to upgrade you.";

export const NO_ACCESS_TO_CREATE_AI_DOCUMENT =
  "You don't have access to create AI document. To create it, Ask an admin to upgrade you to a member";

export const NO_ACCESS_TO_MODIFY_APP_CONNECTIONS =
  "You don't have access to modify app connection.";

export const ROLE_WORKSPACE_OWNER_CODE = "workspace_owner";
export const ROLE_WORKSPACE_GUEST_CODE = "workspace_guest";
export const ROLE_WORKSPACE_MEMBER_CODE = "workspace_member";
export const ROLE_WORKSPACE_ADMIN_CODE = "workspace_admin";

export const ROLE_STORY_OWNER_CODE = "story_owner";
export const ROLE_STORY_EDITOR_CODE = "story_editor";
export const ROLE_STORY_VIEWER_CODE = "story_viewer";
export const ROLE_STORY_COMMENTOR_CODE = "story_commentor";

export const UpdateSourceTypes = {
  SYSTEM: "system",
  USER: "user",
};

export const ContentTypes = {
  STORY: "story",
  ASSET: "tldrasset",
  AI_DOCUMENT: "document",
  TEAM_TEMPLATE: "tldrtemplate",
  FOLDER: "folder",
};

export const ImageMimeTypes = [
  "image/jpg",
  "image/jpeg",
  "image/png",
  "image/svg+xml",
  "image/heic",
  "image/heif",
  "image/gif", // To handle GIF
];

export const ASSET_MAX_FILE_UPLOAD_SIZE = 500 * 1024 * 1024; // file size in bytes
export const ASSETS_ALLOWED_FILE_EXTENSIONS = [
  ...[
    "video/*", // Video files
    "audio/*", // Audio files
    "font/*", // Font files
    "image/*",
  ],
  ...ImageMimeTypes,
]; // Image files (Consists of GIF and SVG as well)

export const getPhotoMaxSize = () => 1024 * 1024 * 5;

export const BODY_SCROLL_LOCK_IGNORE = "bodyscrolllockignore";
